<template>
    <div
        class="grid gap-4 grid-cols-1 sm:grid-cols-2"
    >
        <select-input
            v-model="proxyOpensAt"
            :error="opensAtError"
            :label="opensLabel"
            :name="opensName"
        >
            <option :value="null" disabled>Please select one</option>
            <option v-for="(time, index) in timeOptions" :key="index" :value="time.value" :disabled="openOptionDisabled(time.value)">{{ time.text }}</option>
        </select-input>

        <select-input
            v-model="proxyClosesAt"
            :error="closesAtError"
            :label="closesLabel"
            :name="closesName"
        >
            <option :value="null" disabled>Please select one</option>
            <option v-for="(time, index) in timeOptions" :key="index" :value="time.value" :disabled="closeOptionDisabled(time.value)">{{ time.text }}</option>
        </select-input>
    </div>
</template>

<script>
import SelectInput from './SelectInput'
import { capitalize, range } from 'lodash'

export default {
    props: {
        opensAt: {
            type: Number
        },
        closesAt: {
            type: Number
        },
        day: {
            type: String,
            required: true,
        },
        opensAtError: String,
        closesAtError: String,
    },
    emit: ['update:opensAt', 'update:closesAt'],
    computed: {
        opensName() {
            return `opens_${this.day.toLowerCase()}_at`
        },
        closesName() {
            return `closes_${this.day.toLowerCase()}_at`
        },
        opensLabel() {
            return `Opens ${capitalize(this.day)}`
        },
        closesLabel() {
            return `Closes ${capitalize(this.day)}`
        },
        timeOptions() {
            return range(1, 25).map(value => {
                let text
                if(value == 12) {
                    text = '12 pm'
                } else if (value == 24) {
                    text = '12 am'
                } else {
                    text = value < 13 ? `${value} am` : `${value - 12} pm`
                }
                return { value, text }
            })
        },
        proxyOpensAt: {
            get() {
                return this.opensAt
            },
            set(val) {
                this.$emit('update:opensAt', val)
            }
        },
        proxyClosesAt: {
            get() {
                return this.closesAt
            },
            set(val) {
                this.$emit('update:closesAt', val)
            }
        },
    },
    methods: {
        openOptionDisabled(time) {
            return this.proxyClosesAt && time >= this.proxyClosesAt
        },
        closeOptionDisabled(time) {
            return this.proxyOpensAt && time <= this.proxyOpensAt
        }
    },
    components: {
        SelectInput
    }
}
</script>
